/**
 * Generated file
 * Do not edit directly
 */
import React from 'react';
import { Icon, IconProps } from '@chakra-ui/react';

export const YoutubeIcon = ({ css, ...props }: IconProps) => {
  return (
    <Icon
      height="24px"
      width="24px"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.8153 5.41818C20.6763 5.64867 21.353 6.32532 21.5835 7.18637H21.5818C22 8.74547 22 12.0003 22 12.0003C22 12.0003 22 15.2552 21.5818 16.8143C21.3513 17.6753 20.6747 18.352 19.8136 18.5825C18.2545 19.0007 12 19.0007 12 19.0007C12 19.0007 5.74547 19.0007 4.18637 18.5825C3.32532 18.352 2.64867 17.6753 2.41818 16.8143C2 15.2552 2 12.0003 2 12.0003C2 12.0003 2 8.74547 2.41818 7.18637C2.64867 6.32532 3.32532 5.64867 4.18637 5.41818C5.74547 5 12 5 12 5C12 5 18.2545 5 19.8153 5.41818ZM15.1973 12.0003L9.99969 15V9.00066L15.1973 12.0003Z"
        fill="currentColor"
      ></path>
    </Icon>
  );
};
